import React, { useEffect, useState } from "react";
import { Modal, Button } from "antd";
import "antd/dist/reset.css";
import "./DataPreviewModal.scss";
import "./UpiIdModal.scss";

const PAYOK_COUNTRY_CONFIG = [
  {
    country: "india",
    label: "UPI ID",
    required: true,
    sublabel: "Payer's UPI ID, for example yourname@upi",
    placeholder: "yourname@bank",
  },
  {
    country: "brazil",
    label: "PIX ID",
    required: true,
    sublabel: "Payer's PIX ID",
    placeholder: "Enter PIX ID",
  },
  {
    country: "colombia",
    label: "NEQUI ID",
    required: false,
    sublabel: "Payer's NEQUI ID (optional)",
    placeholder: "Enter NEQUI ID",
  },
];

const DEFAULT_PAYOK_CONFIG = {
  label: "Personal ID",
  required: false,
  sublabel: "Payer's Personal ID (optional)",
  placeholder: "Enter Personal ID",
};

export const UpiIdModal = ({ open, onClose, onProceed, country }) => {
  const [upiInput, setUpiInput] = useState("");
  const [error, setError] = useState("");

  const normalizedCountry = country?.toLowerCase();
  const config =
    PAYOK_COUNTRY_CONFIG.find((item) => item.country === normalizedCountry) ??
    DEFAULT_PAYOK_CONFIG;
  const { label, required: isRequired, sublabel, placeholder } = config;

  useEffect(() => {
    if (open) {
      setUpiInput("");
      setError("");
    }
  }, [open]);

  const handleProceed = () => {
    if (isRequired && !upiInput.trim()) {
      setError(`${label} is required.`);
      return;
    }
    setError("");
    onProceed(upiInput.trim());
  };

  const handleCancel = () => {
    setError("");
    onClose();
  };

  return (
    <Modal
      title={label}
      open={open}
      className="custom-modal upi-id-modal"
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button key="proceed" type="primary" onClick={handleProceed}>
          Proceed
        </Button>,
      ]}
    >
      <div className="upi-id-modal_body">
        <p className="upi-id-modal_sublabel">{sublabel}</p>
        <input
          type="text"
          className={`upi-id-modal_input ${error ? "has-error" : ""}`}
          placeholder={placeholder}
          value={upiInput}
          onChange={(e) => {
            setUpiInput(e.target.value);
            if (error) setError("");
          }}
        />
        {error && <small className="upi-id-modal_error">{error}</small>}
      </div>
    </Modal>
  );
};
